
<template>
  <div class="empty-cart-container">
    <p class="empty-cart-p p-4">
      Shopping cart is currently empty
      <br />Add items to your cart and view them here before you checkout.
      <router-link to="/">Continue shopping!</router-link>
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style>
.empty-cart-p {
  border: 1px solid #f4ea73;
  background-color: #f8f1a2;
  color: #464646;
}

.empty-cart-container {
  min-height: 33vh;
}
</style>